import VideoUpload from "@/components/VideoUpload";
import { baseUrlt } from "@/api";



export let mixinVideoUpload = {
  data() {
    return {
      vfileFormName: 'ruleForm',//表名
      vfileFieldName: 'file',//字段名
      vtiemFieldName: 'total_time',//字段名
    };
  },
  components: {
    VideoUpload
  },
  mounted() {
  },
  methods: {
    setFormValForKey(result) {
      if(result){
        this[this.vfileFormName][this.vfileFieldName] = result.res.requestUrls[0].split('?')[0];
        this[this.vfileFormName].key = result.name;
        this[this.vfileFormName].size = result.res.size;
      }else{
        this[this.vfileFormName][this.vfileFieldName] = '';
        this[this.vfileFormName].key = '';
        this[this.vfileFormName].size = '';
      }
    },
    setFormTimeForKey(time) {
      this[this.vfileFormName][this.vtiemFieldName] = time;
    }
  }
};
